import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getChecklistTemplateItemsByChecklistTemplate } from "@/api/resources/checklistTemplateItems/api";
import i18n from "@/providers/i18n";

const entities = i18n.t("tasks");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const checklistTemplateItemsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "checklistTemplateItems"],
  lists: () => [...checklistTemplateItemsQueryKeys.all(), "list"],
  listByChecklistTemplate: (checklist_template_id?: string) => [
    ...checklistTemplateItemsQueryKeys.lists(),
    "current",
    checklist_template_id,
  ],
};

export const checklistTemplateItemsQueries = {
  listByChecklistTemplate: (checklist_template_id?: string) =>
    queryOptions({
      queryKey: [...checklistTemplateItemsQueryKeys.listByChecklistTemplate(checklist_template_id)],
      queryFn: checklist_template_id
        ? () => getChecklistTemplateItemsByChecklistTemplate(checklist_template_id)
        : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
};
